var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50553 0.499756H22.5056C23.1499 0.499756 23.6722 1.02208 23.6722 1.66642V20.3331C23.6722 20.9774 23.1499 21.4998 22.5056 21.4998H1.50553C0.861207 21.4998 0.338867 20.9774 0.338867 20.3331V1.66642C0.338867 1.02208 0.861207 0.499756 1.50553 0.499756ZM21.3389 10.9998H2.6722V19.1664H21.3389V10.9998ZM21.3389 6.33309V2.83309H2.6722V6.33309H21.3389Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIcon);
export default __webpack_public_path__ + "static/media/creditCardIcon.2cc36114cd1a70c3b872bc674b443992.svg";
export { ForwardRef as ReactComponent };